import React, { useState } from 'react';
import { isArray } from 'lodash';

import styles from './trendingResearchListStyles.scss';

import TrendingResearchListItem from 'buyside/components/presentation/TrendingResearch/TrendingResearchList/trendingResearchListItem';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { TrendingResearchItemsQuery } from 'interfaces/graphql-typings';

const TrendingResearchList: React.FC<{
  showUserDetails: boolean;
  trendingItems:
    | TrendingResearchItemsQuery['activeConversationIdeas']
    | TrendingResearchItemsQuery['biggestMoverIdeas']
    | TrendingResearchItemsQuery['trendingIdeas'];
}> = ({ showUserDetails, trendingItems }) => {
  const [truncated, setTruncated] = useState(true);

  if (!trendingItems) return null;

  let trendingItemEdges = trendingItems.edges;
  if (!trendingItemEdges || !isArray(trendingItemEdges)) return null;

  const seeMore = truncated && trendingItemEdges.length > 5;
  if (seeMore) trendingItemEdges = trendingItemEdges.slice(0, 5);

  return (
    <div className={styles.trendingResearchList}>
      {trendingItemEdges.map((edge: any, idx: number) => (
        <TrendingResearchListItem
          trendingItem={edge.node}
          key={`${idx}-${edge.node.id}`}
          number={idx + 1}
          percentageChange={edge.node.thirtyDayReturnChange}
          showUserDetails={showUserDetails}
        />
      ))}
      {seeMore && (
        <Button
          text="See More..."
          onClick={(): void => {
            setTruncated(false);
          }}
          type={BUTTON_TYPES.LINK}
        />
      )}
    </div>
  );
};

export default TrendingResearchList;
